import { SettingsNavLinks } from "../../components/SettingsNavLinks";
import { ActivationBanner } from "../../components";
import { Card } from "../../components";
import { ToggleSwitch } from "../../components";

import cardIcon from "../../assets/icons/payment-card.svg"
import BankTransferIcon from "../../assets/icons/bank-transfer.svg"
import QrCodeIcon from "../../assets/icons/qr-code.svg"
import  UssdTransferIcon from "../../assets/icons/ussd-transfer.svg"

import paystack from "../../assets/icons/paystack.svg"
import flutterwave from "../../assets/icons/flutterwave.svg"
import stripe from "../../assets/icons/stripe.svg"
import square from "../../assets/icons/square.svg"

import paypal from "../../assets/icons/paypal.svg"
import googlepay from "../../assets/icons/google.svg"
import apple from "../../assets/icons/apple.svg"
import samsungpay from "../../assets/icons/samsung-pay.svg"
import option from "../../assets/icons/option.svg"

export const View = () => {

const IconandSwitch = ({leftIcon, paymentTitle,paymentSubtitle }: 
  {leftIcon :string, paymentTitle :string,paymentSubtitle:string}) => {
  return (
    <div className="payment-method-content">
        <div className="leftIcon-icon">
           <img src = {leftIcon}/>
        </div>
        <div className="payment-and-">
           <strong>{paymentTitle}</strong>
           <p>{paymentSubtitle}</p>
        </div>
        <div className="  payment-toggle-switch ">
           <ToggleSwitch/>
          </div>
    </div>
  )
}

const WalletsandSwitch = ({leftIcon, paymentTitle,paymentSubtitle ,paymentLink}: 
  {leftIcon :string, paymentTitle :string,paymentSubtitle:string,paymentLink:string}) => {
  return (
    <div className="wallet-method-content">
        <div className="leftIcon-icon">
           <img src = {leftIcon}/>
        </div>
        <div className="payment-and-">
           <strong>{paymentTitle}</strong>
           <p>{paymentSubtitle}</p>
           <div className="payment-link-span-color"><span>{paymentLink}</span></div>
        </div>
        <div className="  wallet-payment-toggle-switch ">
           <ToggleSwitch/>
          </div>
    </div>
  )
}

    return(
    <>
      <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Payment Methods"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
          <div className="payment-section-header">
            <strong>Commonly used</strong></div> 
            
          <IconandSwitch
          leftIcon= {cardIcon}
          paymentTitle = "Card"
          paymentSubtitle="Popular for consumers and businesses to pay online or in 
          person. SwitchApp supports global and local card networks."
          />
          <IconandSwitch
          leftIcon= {BankTransferIcon}
          paymentTitle = "Bank Transfer"
          paymentSubtitle="Popular for consumers and businesses 
          to pay online or in person. SwitchApp supports global and local card networks."
          />
          <IconandSwitch
          leftIcon= {UssdTransferIcon}
          paymentTitle = "USSD Transfer"
          paymentSubtitle="Popular for consumers and businesses to pay online or in 
          person. SwitchApp supports global and local card networks."
          />
          <IconandSwitch
          leftIcon= {QrCodeIcon}
          paymentTitle = "QR code"
          paymentSubtitle="Help your customers make payments quickly. 
          Popular for consumers and businesses to pay online or in person."
          />
         
          <div className="payment-section-header"><strong>Gateways</strong></div>
        
          <IconandSwitch
          leftIcon= {paystack}
          paymentTitle = "Paystack"
          paymentSubtitle="Enable customers to pay with paystack"
          />
        
          <IconandSwitch
          leftIcon= {flutterwave}
          paymentTitle = "Flutterwave"
          paymentSubtitle="Enable customers to pay with flutterwave"
          />
          <IconandSwitch
          leftIcon= {stripe}
          paymentTitle = "Stripe"
          paymentSubtitle="Enable customers to pay with stripe"
          />
            <IconandSwitch
          leftIcon= {square}
          paymentTitle = "Square"
          paymentSubtitle="Enable customers to pay with square"
          />

        <div className="payment-section-header"><strong>Wallets</strong></div>

        <WalletsandSwitch
          leftIcon= {paypal}
          paymentTitle = "Paypal"
          paymentSubtitle="Enable customers to pay with paypal"
          paymentLink="Legal agreement for paypal services"
          />
          <WalletsandSwitch
          leftIcon= {googlepay}
          paymentTitle = "Google Pay"
          paymentSubtitle="Enable customers to pay with Google pay in Androids apps and on the web"
          paymentLink="Google Pay Api terms of service Gogle Api terms of service"
          />
          <WalletsandSwitch
          leftIcon= {apple}
          paymentTitle = "Apple Pay"
          paymentSubtitle="Enable customers to pay with Apple Payin Ios apps and safari"
          paymentLink="Apple pay platform web Merchant terms and conditions"
          />
          <WalletsandSwitch
          leftIcon= {samsungpay}
          paymentTitle = "Samsung Pay"
          paymentSubtitle="Enable customers to pay with Samsung Pay"
          paymentLink="Samsung pay SDK license Agreement and Samsung pay promotional Terms "
          />
         <div className="notice-link">
          <img src={option} alt="option-icon" />
          <p>To set up payment method that require action <span>please click here</span></p>
         </div>
      </Card>
     
    </>
    )
}